import { render, staticRenderFns } from "./UIDropdown.vue?vue&type=template&id=14f62457&scoped=true&"
import script from "./UIDropdown.vue?vue&type=script&lang=js&"
export * from "./UIDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f62457",
  null
  
)

export default component.exports